"use client";

import { EventItems } from "./event-items";
import type { SectionEventsProps } from "./types";

import { EventsFilters } from "./components/events-filters";
import { EventsOrder } from "./components/events-order";
import {
  FilterEventsProvider,
  useFilterEvents,
} from "./components/filter-events-context-provider";
import {
  OrderEventsProvider,
  useOrderEventsContext,
} from "./components/order-events-context-provider";
import { SearchEvents } from "./components/search-events";
import { SectionEventsEmpty } from "./components/section-events-empty";
import { SectionEventTranslationProvider } from "./components/translations-section-events-context-provider";

function SectionEventsBase({ blok, ...context }: Readonly<SectionEventsProps>) {
  const { events } = useFilterEvents();
  const { currentEvents, pastEvents } = useOrderEventsContext();

  const currentEventsHeader = blok.currentEventsHeader?.[0];
  const pastEventsHeader = blok.pastEventsHeader?.[0];

  if (!events.length || !blok) return null;

  return (
    <div className="flex flex-col gap-xl">
      <div className="flex flex-col justify-between gap-sm sm:flex-row">
        <SearchEvents />
        <div className="flex justify-between gap-xs sm:justify-normal sm:gap-sm">
          <EventsOrder />
          <EventsFilters />
        </div>
      </div>

      <EventItems
        blok={blok}
        header={currentEventsHeader}
        events={currentEvents}
        {...context}
      />

      <EventItems
        blok={blok}
        header={pastEventsHeader}
        events={pastEvents}
        {...context}
      />

      <SectionEventsEmpty />
    </div>
  );
}

function SectionEvents(props: Readonly<SectionEventsProps>) {
  const blok = props.blok;
  const events = props.blok.events ?? [];

  return (
    <SectionEventTranslationProvider blok={blok}>
      <FilterEventsProvider events={events}>
        <OrderEventsProvider>
          <SectionEventsBase {...props} />
        </OrderEventsProvider>
      </FilterEventsProvider>
    </SectionEventTranslationProvider>
  );
}

export { SectionEvents };
